// src/pages/PlatformSettingsPage.jsx
import React, { useState } from 'react';
import {
  Box, Typography, Paper, Tabs, Tab, Container, Alert, Grid,
  Card, CardContent, CardHeader, Avatar, Button, CircularProgress // Added CircularProgress
} from '@mui/material';
import {
  Dns as DnsIcon, // This was missing
  VpnKey as ApiKeysIcon,
  // Security as SecurityIcon,
  // MonetizationOn as BillingIcon,
  // Group as UserManagementIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useModels } from '../hooks/useModels';

const ModelCatalogSection = () => {
  const [models, loadingModels, modelError] = useModels();

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>LLM Model Catalog</Typography>
      {loadingModels && <CircularProgress />} {/* Now defined */}
      {modelError && <Alert severity="error">Error loading models: {modelError.message || modelError}</Alert>}
      {!loadingModels && !modelError && (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            View and manage available Large Language Models for your agents.
          </Typography>
          {models.length > 0 ? (
            <Grid container spacing={2}>
              {models.map(model => (
                <Grid item xs={12} sm={6} md={4} key={model.id}>
                  <Card variant="outlined">
                    <CardHeader
                      avatar={<Avatar sx={{ bgcolor: 'primary.light', color: 'primary.dark' }}><DnsIcon /></Avatar>}
                      title={model.name || model.id}
                      subheader={model.id}
                      titleTypographyProps={{variant: 'subtitle1', fontWeight: 'medium'}}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>No models found or configured.</Typography>
          )}
        </Box>
      )}
       <Button variant="outlined" sx={{mt:2}} onClick={() => alert("Model management UI not yet implemented.")}>
        Manage Models
      </Button>
    </Paper>
  );
}

const ApiKeysSettingsSection = () => {
  const navigate = useNavigate();
  return (
    <Paper elevation={2} sx={{p:3}}>
      <Typography variant="h6" gutterBottom>API Key Management</Typography>
      <Typography variant="body2" color="text.secondary" sx={{mb:2}}>
        Manage your platform API keys for programmatic access and integrations.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/apikeys')} startIcon={<ApiKeysIcon/>}>
        Go to API Keys
      </Button>
    </Paper>
  )
}


const PlatformSettingsPage = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const TABS = [
    { label: 'Model Catalog', icon: <DnsIcon />, component: <ModelCatalogSection /> }, // DnsIcon for ModelCatalog
    { label: 'API Keys', icon: <ApiKeysIcon />, component: <ApiKeysSettingsSection /> },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
        Platform Settings
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Paper elevation={1} sx={{p:1}}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={currentTab}
              onChange={handleTabChange}
              aria-label="Platform settings tabs"
              sx={{ borderRight: 1, borderColor: 'divider', minHeight: 200 }}
            >
              {TABS.map((tab, index) => (
                <Tab 
                  key={index} 
                  icon={tab.icon} 
                  iconPosition="start" 
                  label={tab.label} 
                  sx={{alignItems: 'flex-start', textTransform: 'none', '& .MuiTab-wrapper': { flexDirection: 'row', justifyContent: 'flex-start'}}} 
                  id={`setting-tab-${index}`}
                  aria-controls={`setting-tabpanel-${index}`}
                />
              ))}
            </Tabs>
          </Paper>
        </Grid>
        <Grid item xs={12} md={9}>
          {TABS.map((tab, index) => (
            <Box
              key={index}
              role="tabpanel"
              hidden={currentTab !== index}
              id={`setting-tabpanel-${index}`}
              aria-labelledby={`setting-tab-${index}`}
            >
              {currentTab === index && (
                <Box>
                  {tab.component}
                </Box>
              )}
            </Box>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
};

export default PlatformSettingsPage;